import React from 'react';
import { Link } from 'react-router-dom';

import useGlobalState from '../GlobalStateContext';

export default function ViewButton({ url, roles = [], permissions = [], title = '' }) {
    const { loggedAdmin } = useGlobalState();

    return loggedAdmin.hasAccess(roles, permissions) ? (
        <Link className="btn btn-primary btn-sm square-button" key="details" to={url} title={title}>
            <i className="fa fa-eye" />
        </Link>
    ) : null;
}
